import React, { createContext, useContext, useMemo, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const StudioAuthContext = createContext(null);

export const StudioAuthProvider = ({ children }) => {
  const [pin, setPin] = useState(null);

  const value = useMemo(() => ({
    unlocked: Boolean(pin),
    async unlock(candidate) {
      const response = await fetch(`${API}/studio/verify`, {
        method: "POST",
        headers: { "X-Studio-Pin": candidate },
      });
      if (!response.ok) throw new Error("Invalid operator PIN");
      setPin(candidate);
    },
    lock() { setPin(null); },
    async request(path, options = {}) {
      const headers = new Headers(options.headers || {});
      headers.set("X-Studio-Pin", pin || "");
      if (options.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
      const response = await fetch(`${API}${path}`, { ...options, headers });
      if (response.status === 401) setPin(null);
      return response;
    },
  }), [pin]);

  return <StudioAuthContext.Provider value={value}>{children}</StudioAuthContext.Provider>;
};

export const useStudioAuth = () => {
  const context = useContext(StudioAuthContext);
  if (!context) throw new Error("useStudioAuth must be used inside StudioAuthProvider");
  return context;
};